import { render } from "./simpleTab.vue?vue&type=template&id=4eed0322"
import script from "./simpleTab.vue?vue&type=script&lang=js"
export * from "./simpleTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__